import { apiRequest } from "./apiClient";
import { trackEngagementDataAdded } from "./engagementService";

export async function getCookingSettings(familyId, lang = "tr") {
  if (!familyId) return { begeniPuanlari: {}, gecmis: [] };
  const data = await apiRequest(`/cooking/${encodeURIComponent(familyId)}?lang=${encodeURIComponent(lang || "tr")}`);
  return data.settings || { begeniPuanlari: {}, gecmis: [] };
}

export async function saveCookingSettings(familyId, settings = {}, lang = "tr") {
  if (!familyId) return { begeniPuanlari: {}, gecmis: [] };
  const data = await apiRequest(`/cooking/${encodeURIComponent(familyId)}?lang=${encodeURIComponent(lang || "tr")}`, {
    method: "PUT",
    body: JSON.stringify({
      begeniPuanlari: settings.begeniPuanlari || {},
      gecmis: Array.isArray(settings.gecmis) ? settings.gecmis : [],
    }),
  });
  trackEngagementDataAdded({ familyId, moduleKey: "cooking", metadata: { source: "settings_saved" } });
  return data.settings || settings;
}
